import type { DialogProps as MuiDialogProps } from '@mui/material/Dialog';
import { StyledDialog, StyledBackdrop } from './Dialog.style';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import CloseIcon from 'shared/icons/Close';

export type DialogProps = {
  fullHeight?: boolean;
  hideCloseButton?: boolean;
} & MuiDialogProps;

const Dialog = ({
  children,
  fullHeight = false,
  hideCloseButton = false,
  ...rest
}: DialogProps) => {
  return (
    <StyledDialog
      fullHeight={fullHeight}
      slots={{ backdrop: StyledBackdrop }}
      {...rest}
    >
      {!hideCloseButton && (
        <Stack
          direction="row"
          justifyContent="flex-end"
          sx={{ padding: '10px' }}
        >
          <IconButton
            onClick={(event) =>
              rest.onClose && rest.onClose(event, 'backdropClick')
            }
            sx={{ padding: '2px', background: '#F0F3F7' }}
          >
            <CloseIcon
              sx={{
                fontSize: '1.3rem',
                color: (theme) => theme.palette.primary.main,
              }}
            />
          </IconButton>
        </Stack>
      )}

      <Stack
        sx={{
          flex: 1,
          padding: { md: '30px', xs: '15px' },
          paddingTop: '15px',
        }}
      >
        {children}
      </Stack>
    </StyledDialog>
  );
};

export default Dialog;
